import { IPlatform } from './PlatformSelect/platformSelect';

export const availablePlatforms: IPlatform[] = [
	{
		name: 'Software Key',
		value: 'software-key',
		icon: '/assets/icons/key.png',
	},
	{
		name: 'form.steps.setPlatform.browser',
		value: 'html',
		icon: '/assets/icons/html.svg',
	},
	{
		name: 'Ticket',
		value: 'ticket',
		icon: '/assets/icons/ticket.svg',
	},
	{
		name: 'Windows',
		value: 'pc',
		icon: '/assets/icons/pc.svg',
	},
	{
		name: 'Web3',
		value: 'web3',
		icon: '/assets/icons/code.svg',
	},
	{
		name: 'form.steps.setPlatform.comingSoon',
		value: 'macos',
		icon: '/assets/icons/apple.svg',
		soon: true,
	},
];
